/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';
import { t } from 'utils/translates';

import { selectRating } from 'mt-react-common/modules/users/common/reducers/states/authAccount';

import { sendRequest as sendTaskToggleChosenMarkFormRequest } from 'mt-react-common/modules/tasks/common/reducers/taskToggleChosenMarkForm';
import { sendRequest as sendTaskToggleHideMarkFormRequest } from 'mt-react-common/modules/tasks/common/reducers/taskToggleHideMarkForm';

import TaskPanelHeaderAsExec from '../../_common/TaskPanelHeaderAsExec';
import TaskPanelBodyAsExec from '../../_common/TaskPanelBodyAsExec';

// eslint-disable-next-line react/prefer-stateless-function
class TaskItemNewTasks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      markHideButtonId: `markHideButton-${this.props.task.id}`,
      markChosenButton: `markChosenButton-${this.props.task.id}`
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.task.markHide !== this.props.task.markHide) {
      // eslint-disable-next-line no-undef
      $(`#${this.state.markHideButtonId}`)
        .tooltip('fixTitle')
        .tooltip('hide');
    }
    if (prevProps.task.markChosen !== this.props.task.markChosen) {
      // eslint-disable-next-line no-undef
      $(`#${this.state.markChosenButton}`)
        .tooltip('fixTitle')
        .tooltip('hide');
    }
  }

  render() {
    const styles = {};
    if (this.props.task.reasonsLockedForExecution.length > 0) {
      styles.opacity = 0.5;
    }
    const isShowActionButtonsForTask =
      !this.props.isTaskFromAuthUser &&
      !this.props.task.reasonsLockedForExecution.length > 0;
    return (
      <React.Fragment>
        <article
          className={`panel task task_detailed panel-default ${
            this.props.task.upListMarkNow !== null ? 'panel-primary' : ''
          }`}
          style={styles}
        >
          <TaskPanelHeaderAsExec
            task={this.props.task}
            isTaskFromAuthUser={this.props.isTaskFromAuthUser}
          />
          <div className="panel-body">
            <TaskPanelBodyAsExec
              task={this.props.task}
              isTaskFromAuthUser={this.props.isTaskFromAuthUser}
            />
          </div>
          <div className="panel-footer panel-inner-border-top">
            <div className="btn-toolbar">
              <div className="btn-group btn-group-sm pull-left">
                <div className="btn btn-default btn-view">
                  <span
                    className="text-success"
                    data-container="body"
                    data-toggle="tooltip"
                    title={
                      this.props.task.tasksExecsStat.statuses[4].execStatusTitle
                    }
                  >
                    {
                      this.props.task.tasksExecsStat.statuses[4]
                        .execCountByStatus
                    }
                  </span>{' '}
                  <span className="text-muted">•</span>{' '}
                  <span
                    data-container="body"
                    data-toggle="tooltip"
                    title={
                      this.props.task.tasksExecsStat.statuses[2].execStatusTitle
                    }
                  >
                    {
                      this.props.task.tasksExecsStat.statuses[2]
                        .execCountByStatus
                    }
                  </span>{' '}
                  <span className="text-muted">•</span>{' '}
                  <span
                    className="text-danger"
                    data-container="body"
                    data-toggle="tooltip"
                    title={
                      this.props.task.tasksExecsStat.disputesFromExecutors.desc
                    }
                  >
                    {this.props.task.tasksExecsStat.disputesFromExecutors.count}
                  </span>
                </div>
                <div className="btn btn-default btn-view">
                  <span
                    data-container="body"
                    data-toggle="tooltip"
                    title={t('Положительные отзывы')}
                  >
                    <i className="text-primary fa fa-thumbs-o-up" />{' '}
                    <span className="text-muted">
                      {this.props.task.taskCommentsStat.likes}
                    </span>
                  </span>{' '}
                  <span
                    data-container="body"
                    data-toggle="tooltip"
                    title={t('Отрицательные отзывы')}
                  >
                    <i className="text-primary fa fa-thumbs-o-down" />{' '}
                    <span className="text-muted">
                      {this.props.task.taskCommentsStat.dislikes}
                    </span>
                  </span>
                </div>
                {this.props.task.adultContent === 1 ? (
                  <div className="btn btn-default btn-view">
                    <span
                      className="text-danger"
                      data-container="body"
                      data-toggle="tooltip"
                      title={t('Контент для лиц достигших совершеннолетия')}
                    >
                      <strong>18+</strong>
                    </span>
                  </div>
                ) : null}
                {this.props.task.softwareInstall === 1 ? (
                  <div className="btn btn-default btn-view">
                    <span
                      className="text-danger"
                      data-container="body"
                      data-toggle="tooltip"
                      title={t('Задание требует установку ПО')}
                    >
                      <strong>{t('ПО')}</strong>
                    </span>
                  </div>
                ) : null}
              </div>
              {this.props.task.reasonsLockedForExecution.length > 0 ? (
                <button
                  className="btn btn-default btn-sm"
                  type="button"
                  data-container="body"
                  data-toggle="tooltip"
                  title={this.props.task.reasonsLockedForExecution.join(', ')}
                >
                  {t('Выполнить')}
                </button>
              ) : null}
              {isShowActionButtonsForTask ? (
                <Link
                  to={`/earn-money/task-view/${this.props.task.id}`}
                  className="btn btn-success btn-sm"
                  type="button"
                >
                  {t('Выполнить')}
                </Link>
              ) : null}
              {this.props.task.markHide && isShowActionButtonsForTask ? (
                <button
                  id={this.state.markHideButtonId}
                  className="btn btn-muted btn-sm"
                  data-toggle="tooltip"
                  type="button"
                  title={`${this.props.task.markHide.buttonMessage}`}
                  onClick={() => this.props.taskToggleHideMark()}
                >
                  <i
                    className={`fa ${
                      this.props.task.markHide.marked
                        ? 'fa-eye-slash'
                        : 'fa-eye'
                    }`}
                  />
                </button>
              ) : null}
              {this.props.task.markChosen && isShowActionButtonsForTask ? (
                <button
                  id={this.state.markChosenButton}
                  className="btn btn-muted btn-sm"
                  data-toggle="tooltip"
                  type="button"
                  title={`${this.props.task.markChosen.buttonMessage}`}
                  onClick={() => this.props.taskToggleChosenMark()}
                >
                  <i
                    className={`fa ${
                      this.props.task.markChosen.marked
                        ? 'fa-bookmark'
                        : 'fa-bookmark-o'
                    }`}
                  />
                </button>
              ) : null}
            </div>
          </div>
        </article>
      </React.Fragment>
    );
  }
}

TaskItemNewTasks.propTypes = {
  // IN
  isTaskFromAuthUser: PropTypes.bool.isRequired,
  task: PropTypes.shape({
    id: PropTypes.number.isRequired,
    adultContent: PropTypes.number.isRequired,
    softwareInstall: PropTypes.number.isRequired,
    pExecutorMinRating: PropTypes.number.isRequired,
    reasonsLockedForExecution: PropTypes.arrayOf(PropTypes.string),
    markHide: PropTypes.shape({
      marked: PropTypes.bool,
      buttonMessage: PropTypes.string
    }).isRequired,
    markChosen: PropTypes.shape({
      marked: PropTypes.bool,
      buttonMessage: PropTypes.string
    }).isRequired,
    taskCommentsStat: PropTypes.shape({
      likes: PropTypes.number.isRequired,
      dislikes: PropTypes.number.isRequired
    }).isRequired,
    tasksExecsStat: PropTypes.shape({
      statuses: PropTypes.shape({}).isRequired,
      disputesFromExecutors: PropTypes.shape({
        desc: PropTypes.string,
        count: PropTypes.number
      }).isRequired
    }).isRequired,
    upListMarkNow: PropTypes.shape({
      andTime: PropTypes.string
    })
  }).isRequired,
  authUserRating: PropTypes.shape({
    rating: PropTypes.string.isRequired,
    ratingStatusTitle: PropTypes.string.isRequired,
    ratingStatusPoints: PropTypes.number.isRequired,
    ratingStatusPointsTo: PropTypes.number.isRequired
  }).isRequired,
  // CONNECT
  taskToggleChosenMark: PropTypes.func.isRequired,
  taskToggleHideMark: PropTypes.func.isRequired
};

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state, props) => ({
  authUserRating: selectRating(state)
});

const mapDispatchToProps = (dispatch, props) => ({
  taskToggleChosenMark: () =>
    dispatch(
      sendTaskToggleChosenMarkFormRequest(
        'tasksModule.forms.taskToggleChosenMarkForm',
        props.task.id
      )
    ),
  taskToggleHideMark: () =>
    dispatch(
      sendTaskToggleHideMarkFormRequest(
        'tasksModule.forms.taskToggleHideMarkForm',
        props.task.id
      )
    )
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TaskItemNewTasks)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksListNewTasks/TaskItemNewTasks/TaskItemNewTasks.js